/**
 * Normalize the `testimonials` value on a TestimonialListingBlock model into a
 * flat, null-free array the template can iterate safely.
 *
 * The value reaches the block in two shapes, both of which crash a naive
 * `v-for` server-side (P180PCM-279):
 *
 *  1. The raw Content-Delivery property wrapper, e.g. on /contact-us/:
 *
 *       { expandedValue: [ {testimonial}, ... ],
 *         value: [...refs] | null,
 *         propertyDataType: 'PropertyContentArea' }
 *
 *     `model.testimonials ?? []` hands this object straight to `v-for`, and
 *     iterating an *object* walks its values — the `expandedValue` array, the
 *     `value` (usually null) and the `propertyDataType` string — so the loop
 *     dereferences a null/string as if it were a testimonial and throws.
 *
 *  2. An already-unwrapped flat array that may contain null entries, e.g. on the
 *     homepage after the expire-content job (P180PCM-265) unpublishes a
 *     referenced testimonial: the expired reference expands to `null`, leaving
 *     `[ {testimonial}, null, {testimonial} ]`. `v-for` hits the null and
 *     `testimonial.aprimoMainImage` throws.
 *
 * Unwrap the wrapper (preferring `expandedValue`, falling back to `value`),
 * accept an already-flat array as-is, and drop nulls in every case.
 */
export function normalizeTestimonials(raw: any): any[] {
  const list = Array.isArray(raw)
    ? raw
    : (raw?.expandedValue ?? raw?.value ?? [])

  return (Array.isArray(list) ? list : []).filter(Boolean)
}
